import {
  handleHTML,
  parseHTML,
  safeHTML,
  serializeMarkdown,
  serializePlaintext,
  serializeSafeHTML,
  tidyDOM,
  vdom,
  xml
} from "./chunk-MR7V3FOC.js";
import {
  CDATA,
  VDocType,
  VDocument,
  VDocumentFragment,
  VElement,
  VHTMLDocument,
  VNode,
  VNodeQuery,
  VTextNode,
  createDocument,
  createHTMLDocument,
  document,
  escapeHTML,
  h,
  hArgumentParser,
  hFactory,
  hasOwn,
  html,
  isVDocument,
  isVElement,
  isVTextElement,
  removeBodyContainer,
  unescapeHTML
} from "./chunk-YMRUYF4I.js";
export {
  CDATA,
  VDocType,
  VDocument,
  VDocumentFragment,
  VElement,
  VHTMLDocument,
  VNode,
  VNodeQuery,
  VTextNode,
  createDocument,
  createHTMLDocument,
  document,
  escapeHTML,
  h,
  hArgumentParser,
  hFactory,
  handleHTML,
  hasOwn,
  html,
  isVDocument,
  isVElement,
  isVTextElement,
  parseHTML,
  removeBodyContainer,
  safeHTML,
  serializeMarkdown,
  serializePlaintext,
  serializeSafeHTML,
  tidyDOM,
  unescapeHTML,
  vdom,
  xml
};
//# sourceMappingURL=index.browser.js.map